import React from "react";
import { DEAD } from "constants/status";
import DealTable from "components/Global/TablePreferenceColumns/DealTable";
import DeadDealTableColumns from "components/Global/TablePreferenceColumns/DealTableColumns/DeadDealTableColumns";

const deadDealTableScreentype = "dead_deal_table";

export default class DeadDeals extends React.Component {
  render() {
    return (
      <div>
        <DealTable
          screenType={deadDealTableScreentype}
          TableScreenElements={DeadDealTableColumns}
          status={[DEAD]}
          fundId={null}
          rowsPerPage={this.props.rowsPerPage}
          tableConfigItemId={this.props.tableConfigItemId}
          page={this.props.page}
          updateRowsPerPage={this.props.updateRowsPerPage}
          updatePage={this.props.updatePage}
        />
      </div>
    );
  }
}
